/** Parsed name/email from nexusUser.returnValue JSON. */
export interface NexusUserProfile {
  name?: string;
  email?: string;
}

/** returnValue is a JSON string; keys are typically lowercase name/email. */
export function parseNexusUserReturnValue(
  returnValue: string | null | undefined,
): NexusUserProfile | null {
  const raw = (returnValue ?? '').trim();
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const name = pickString(parsed, 'name', 'Name');
    const email = pickString(parsed, 'email', 'Email');
    if (!name && !email) {
      return null;
    }
    return { name, email };
  } catch {
    return null;
  }
}

function pickString(
  obj: Record<string, unknown>,
  ...keys: string[]
): string | undefined {
  for (const key of keys) {
    const v = obj[key];
    if (v == null) {
      continue;
    }
    const s = String(v).trim();
    if (s) {
      return s;
    }
  }
  return undefined;
}
